import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import SubscriptionManagement from "./SubscriptionManagement";
import SubscriptionPlans from "./SubscriptionPlans";
import "./Subscription.css";

const Subscription = ({ user }) => {
  const isAdmin = user?.role === "admin";

  // Non-admins always start on Plans, admins on Management
  const [activeTab, setActiveTab] = useState(isAdmin ? 1 : 0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="subscription-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Subscriptions</h1>
          <p className="page-subtitle">
            {activeTab === 0
              ? "Choose the perfect plan for your organization"
              : "Manage all subscriptions, plans & revenue"}
          </p>
        </div>
      </div>

      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="subscription tabs"
        className="custom-tabs"
        sx={{
          mb: 4,
          "& .MuiTabs-indicator": {
            backgroundColor: "#059669",
            height: "3px",
          },
        }}
      >
        <Tab
          label="Subscription Plans"
          sx={{
            textTransform: "none",
            fontSize: "1.1rem",
            fontWeight: activeTab === 0 ? 700 : 500,
            color: activeTab === 0 ? "#059669" : "#64748b",
          }}
        />

        {isAdmin && (
          <Tab
            label="Subscription Management"
            sx={{
              textTransform: "none",
              fontSize: "1.1rem",
              fontWeight: activeTab === 1 ? 700 : 500,
              color: activeTab === 1 ? "#059669" : "#64748b",
            }}
          />
        )}
      </Tabs>

      <div className="tab-content">
        {activeTab === 0 && <SubscriptionPlans user={user} />}
        {activeTab === 1 && isAdmin && <SubscriptionManagement />}
      </div>
    </div>
  );
};

export default Subscription;